export default "__VITE_ASSET__DhxdhdpZ__"